// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Js_json from "rescript/lib/es6/js_json.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as I18next$LiveRoom from "../bindings/I18next.bs.js";
import * as MomentTZ$LiveRoom from "../bindings/MomentTZ.bs.js";
import * as ClockStore$LiveRoom from "../stores/ClockStore.bs.js";
import * as CommonStyles$LiveRoom from "../styles/CommonStyles.bs.js";
import * as Utils_Shared$LiveRoom from "../Utils/Utils_Shared.bs.js";
import * as Utils_Session$LiveRoom from "../Utils/Utils_Session.bs.js";
import * as SterlingTokens$LiveRoom from "../bindings/SterlingTokens.bs.js";
import * as StyleConstants$LiveRoom from "../styles/StyleConstants.bs.js";
import * as ClientapiQueries$LiveRoom from "../ClientapiQueries.bs.js";
import * as SterlingTypography$LiveRoom from "../bindings/SterlingTypography.bs.js";

function HeaderSessionIndicator$Paragraph14Regular(props) {
  return React.createElement(SterlingTypography$LiveRoom.Paragraph14Regular.make, {
              className: Curry._1(Css.style, {
                    hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey100_nohashtag)),
                    tl: {
                      hd: CommonStyles$LiveRoom.mediaV2(/* Mobile */1, {
                            hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryWhite_nohashtag)),
                            tl: {
                              hd: Css.alignSelf("center"),
                              tl: /* [] */0
                            }
                          }),
                      tl: /* [] */0
                    }
                  }),
              children: props.text
            });
}

var Paragraph14Regular = {
  make: HeaderSessionIndicator$Paragraph14Regular
};

function HeaderSessionIndicator$Label14Medium(props) {
  return React.createElement(SterlingTypography$LiveRoom.Label14Medium.make, {
              className: Curry._1(Css.style, {
                    hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey100_nohashtag)),
                    tl: {
                      hd: Css.marginLeft(Css.px(4)),
                      tl: {
                        hd: CommonStyles$LiveRoom.mediaV2(/* Mobile */1, {
                              hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryWhite_nohashtag)),
                              tl: {
                                hd: Css.alignSelf("center"),
                                tl: /* [] */0
                              }
                            }),
                        tl: /* [] */0
                      }
                    }
                  }),
              children: props.text
            });
}

var Label14Medium = {
  make: HeaderSessionIndicator$Label14Medium
};

function HeaderSessionIndicator$HeaderDot(props) {
  return React.createElement(SterlingTypography$LiveRoom.Paragraph16Regular.make, {
              className: Curry._1(Css.style, {
                    hd: Css.margin2("zero", Css.px(8)),
                    tl: {
                      hd: Css.alignSelf(Css.center),
                      tl: /* [] */0
                    }
                  }),
              children: StyleConstants$LiveRoom.bullet
            });
}

var HeaderDot = {
  make: HeaderSessionIndicator$HeaderDot
};

function HeaderSessionIndicator$SessionStartIn(props) {
  var t2 = props.t2;
  var min = props.min;
  var hour = props.hour;
  return React.createElement("div", {
              className: Curry._1(Css.style, {
                    hd: Css.display("flex"),
                    tl: {
                      hd: Css.justifyContent("center"),
                      tl: /* [] */0
                    }
                  })
            }, React.createElement(HeaderSessionIndicator$Paragraph14Regular, {
                  text: Curry._2(t2, "Header_startsIn", {
                        sessionName: props.sessionName
                      })
                }), hour >= 1 && min < 1 ? React.createElement(HeaderSessionIndicator$Label14Medium, {
                    text: Curry._2(t2, "TimerHour", {
                          hours: hour | 0
                        })
                  }) : (
                hour < 1 ? React.createElement(HeaderSessionIndicator$Label14Medium, {
                        text: Curry._2(t2, "TimerMinutes", {
                              minutes: min | 0
                            })
                      }) : React.createElement(HeaderSessionIndicator$Label14Medium, {
                        text: Curry._2(t2, "TimerHourMin", {
                              hours: hour | 0,
                              minutes: min | 0
                            })
                      })
              ));
}

var SessionStartIn = {
  make: HeaderSessionIndicator$SessionStartIn
};

function HeaderSessionIndicator$SessionStartInDay(props) {
  var t2 = props.t2;
  var hour = props.hour;
  var day = props.day;
  return React.createElement("div", {
              className: Curry._1(Css.style, {
                    hd: Css.display("flex"),
                    tl: {
                      hd: Css.justifyContent("center"),
                      tl: /* [] */0
                    }
                  })
            }, React.createElement(HeaderSessionIndicator$Paragraph14Regular, {
                  text: Curry._2(t2, "Header_startsIn", {
                        sessionName: props.sessionName
                      })
                }), hour < 1 ? React.createElement(HeaderSessionIndicator$Label14Medium, {
                    text: Curry._2(t2, "TimerDays", {
                          days: day
                        })
                  }) : React.createElement(HeaderSessionIndicator$Label14Medium, {
                    text: Curry._2(t2, "TimerDaysHours", {
                          days: day,
                          hours: hour
                        })
                  }));
}

var SessionStartInDay = {
  make: HeaderSessionIndicator$SessionStartInDay
};

function HeaderSessionIndicator$NextSessionCountdownInfo(props) {
  var t2 = props.t2;
  var sessionName = props.sessionName;
  var countdown = props.countdown;
  if (typeof countdown !== "number") {
    switch (countdown.TAG | 0) {
      case /* LessThen24hours */0 :
          var match = countdown._0;
          var min = match.min;
          var hour = match.hour;
          if (hour >= 1 || min >= 1) {
            return React.createElement(HeaderSessionIndicator$SessionStartIn, {
                        sessionName: sessionName,
                        hour: hour,
                        min: min,
                        t2: t2
                      });
          }
          break;
      case /* DaysUntil */1 :
          return React.createElement(HeaderSessionIndicator$Paragraph14Regular, {
                      text: Curry._2(t2, "Header_starts", {
                            sessionName: sessionName,
                            sessionDate: MomentTZ$LiveRoom.momentFormat(Belt_Option.getWithDefault(Js_json.decodeString(props.sessionTime), ""), "MMMM D, HH:mm zz")
                          })
                    });
      case /* TimeUntilReached */2 :
          var match$1 = countdown._0;
          return React.createElement(HeaderSessionIndicator$SessionStartInDay, {
                      sessionName: sessionName,
                      day: match$1.day,
                      hour: match$1.hour,
                      t2: t2
                    });
      
    }
  }
  return React.createElement(HeaderSessionIndicator$Paragraph14Regular, {
              text: Curry._2(t2, "Header_startsShortly", {
                    sessionName: sessionName
                  })
            });
}

var NextSessionCountdownInfo = {
  make: HeaderSessionIndicator$NextSessionCountdownInfo
};

function HeaderSessionIndicator$NextSessionCountdown(props) {
  var t2 = props.t2;
  var sessionTime = props.sessionTime;
  var session = props.session;
  var match = React.useState(function () {
        return ClockStore$LiveRoom.getServerTime(undefined);
      });
  var setTime = match[1];
  var listener = React.useRef(undefined);
  React.useEffect((function () {
          listener.current = Curry._1(ClockStore$LiveRoom.Emitter.on, (function (data) {
                  var time = data._0;
                  Curry._1(setTime, (function (param) {
                          return Belt_Option.getExn(time);
                        }));
                }));
          return (function (param) {
                    Belt_Option.forEach(listener.current, ClockStore$LiveRoom.Emitter.removeListener);
                  });
        }), []);
  var countdown = Utils_Shared$LiveRoom.Timer.calculateDiffToSpecificTime(match[0], Utils_Shared$LiveRoom.Timer.stringToEpochTime(Belt_Option.getWithDefault(Js_json.decodeString(sessionTime), "")));
  return React.createElement(HeaderSessionIndicator$NextSessionCountdownInfo, {
              countdown: countdown,
              sessionName: Utils_Session$LiveRoom.getSessionName(session.title, session.sessionId, t2),
              sessionTime: sessionTime,
              t2: t2
            });
}

var NextSessionCountdown = {
  make: HeaderSessionIndicator$NextSessionCountdown
};

function HeaderSessionIndicator(props) {
  var sessionOnDisplay = props.sessionOnDisplay;
  var sessions = props.sessions;
  var match = I18next$LiveRoom.useTranslation(undefined);
  var t2 = match.t2;
  var isMultipleSessions = React.useMemo((function () {
          return sessions.length >= 2;
        }), []);
  var isInBetweenSession = React.useMemo((function () {
          if (Belt_Array.some(sessions, (function (x) {
                    return x.state.state === "Open";
                  }))) {
            return false;
          } else {
            return true;
          }
        }), Belt_Array.map(sessions, (function (x) {
              return x.state.state;
            })));
  if (!isMultipleSessions) {
    return null;
  }
  if (!isInBetweenSession) {
    return React.createElement(React.Fragment, undefined, React.createElement("div", {
                    className: Curry._1(Css.style, {
                          hd: Css.display("flex"),
                          tl: {
                            hd: CommonStyles$LiveRoom.mediaV2(/* Mobile */1, {
                                  hd: Css.display("none"),
                                  tl: /* [] */0
                                }),
                            tl: /* [] */0
                          }
                        })
                  }, React.createElement(HeaderSessionIndicator$HeaderDot, {}), React.createElement(HeaderSessionIndicator$Paragraph14Regular, {
                        text: Utils_Session$LiveRoom.getSessionName(Belt_Option.mapWithDefault(sessionOnDisplay, undefined, (function (x) {
                                    return x.title;
                                  })), Belt_Option.mapWithDefault(sessionOnDisplay, 0, (function (x) {
                                    return x.sessionId;
                                  })), t2)
                      })), React.createElement("div", {
                    className: Curry._1(Css.style, {
                          hd: Css.display("none"),
                          tl: {
                            hd: CommonStyles$LiveRoom.mediaV2(/* Mobile */1, {
                                  hd: Css.display("flex"),
                                  tl: /* [] */0
                                }),
                            tl: /* [] */0
                          }
                        })
                  }, React.createElement(HeaderSessionIndicator$Paragraph14Regular, {
                        text: Utils_Session$LiveRoom.getSessionName(Belt_Option.mapWithDefault(sessionOnDisplay, undefined, (function (x) {
                                    return x.title;
                                  })), Belt_Option.mapWithDefault(sessionOnDisplay, 0, (function (x) {
                                    return x.sessionId;
                                  })), t2)
                      })));
  }
  var session = Belt_Array.getBy(sessions, (function (s) {
          return s.state.state === "PreOpen";
        }));
  if (session === undefined) {
    return null;
  }
  var tmp;
  if (sessionOnDisplay !== undefined) {
    var title = sessionOnDisplay.title;
    tmp = title !== undefined ? title : String(sessionOnDisplay.sessionId);
  } else {
    tmp = "0";
  }
  var tmp$1;
  if (sessionOnDisplay !== undefined) {
    var title$1 = sessionOnDisplay.title;
    tmp$1 = title$1 !== undefined ? title$1 : String(sessionOnDisplay.sessionId);
  } else {
    tmp$1 = "0";
  }
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: Curry._1(Css.style, {
                        hd: Css.display("flex"),
                        tl: {
                          hd: CommonStyles$LiveRoom.mediaV2(/* Mobile */1, {
                                hd: Css.display("none"),
                                tl: /* [] */0
                              }),
                          tl: /* [] */0
                        }
                      })
                }, React.createElement(HeaderSessionIndicator$HeaderDot, {}), React.createElement(HeaderSessionIndicator$Paragraph14Regular, {
                      text: Curry._2(t2, "SessionEnded", {
                            sessionName: tmp
                          })
                    }), React.createElement(HeaderSessionIndicator$HeaderDot, {}), React.createElement(HeaderSessionIndicator$NextSessionCountdown, {
                      session: session,
                      sessionTime: session.scheduledOpeningDate,
                      t2: t2
                    })), React.createElement("div", {
                  className: Curry._1(Css.style, {
                        hd: Css.display("none"),
                        tl: {
                          hd: CommonStyles$LiveRoom.mediaV2(/* Mobile */1, {
                                hd: Css.display("flex"),
                                tl: {
                                  hd: Css.flexDirection("column"),
                                  tl: /* [] */0
                                }
                              }),
                          tl: /* [] */0
                        }
                      })
                }, React.createElement(HeaderSessionIndicator$Paragraph14Regular, {
                      text: Curry._2(t2, "SessionEnded", {
                            sessionName: tmp$1
                          })
                    }), React.createElement(HeaderSessionIndicator$NextSessionCountdown, {
                      session: session,
                      sessionTime: session.scheduledOpeningDate,
                      t2: t2
                    })));
}

var SessionStateFragment = ClientapiQueries$LiveRoom.AuctionHeader.SessionStateFragment;

var AuctionHeaderAuctionFragment = ClientapiQueries$LiveRoom.AuctionHeader.AuctionHeaderAuctionFragment;

var make = HeaderSessionIndicator;

export {
  SessionStateFragment ,
  AuctionHeaderAuctionFragment ,
  Paragraph14Regular ,
  Label14Medium ,
  HeaderDot ,
  SessionStartIn ,
  SessionStartInDay ,
  NextSessionCountdownInfo ,
  NextSessionCountdown ,
  make ,
}
/* Css Not a pure module */
